import React, { useEffect, useState } from "react";
import { ArrowDownLeft, ArrowUpRight, Clock, CheckCircle2, XCircle } from "lucide-react";
import api from "@/lib/api";
import { inr } from "@/lib/format";
import { ScreenTitle } from "@/components/ScreenTitle";

const depStatus = {
  pending: { hi: "लंबित", icon: Clock, cls: "bg-amber-100 text-amber-700" },
  accepted: { hi: "स्वीकृत", icon: CheckCircle2, cls: "bg-emerald-100 text-emerald-700" },
  rejected: { hi: "अस्वीकृत", icon: XCircle, cls: "bg-red-100 text-red-700" },
};

export default function HistoryScreen() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    (async () => {
      const [t, d, w] = await Promise.all([
        api.get("/transactions/me"),
        api.get("/deposits/me"),
        api.get("/withdraw-request/me"),
      ]);
      const list = [];
      t.data.forEach((x) => list.push({ kind: "txn", in: x.type === "jama", amount: x.amount, label: x.type === "jama" ? "जमा / Deposit" : "निकासी / Withdrawal", sub: `${x.ref_id} • ${x.note}`, ts: x.timestamp }));
      d.data.forEach((x) => list.push({ kind: "deposit", in: true, amount: x.amount, label: "जमा अनुरोध / Deposit (UTR)", sub: `UTR ${x.utr}`, status: x.status, ts: x.timestamp }));
      w.data.forEach((x) => list.push({ kind: "withdraw", in: false, amount: x.amount, label: "निकासी अनुरोध / Withdraw Request", sub: x.note || "—", status: x.status, ts: x.timestamp }));
      list.sort((a, b) => new Date(b.ts) - new Date(a.ts));
      setItems(list);
    })();
  }, []);

  return (
    <div className="space-y-4">
      <ScreenTitle hi="इतिहास" en="मेरे सभी लेन-देन / All Transactions" />
      {items.length === 0 ? (
        <p className="text-center text-muted-foreground py-10 text-sm">अभी कोई लेन-देन नहीं</p>
      ) : (
        <div className="relative pl-6 space-y-3">
          <div className="absolute left-2 top-2 bottom-2 w-0.5 bg-slate-200" />
          {items.map((it, i) => {
            const S = it.status ? depStatus[it.status] : null;
            return (
              <div key={i} data-testid={`history-item-${i}`} className="relative rounded-2xl bg-white p-3.5 shadow-sm border border-slate-100">
                <span className={`absolute -left-[18px] top-5 h-3 w-3 rounded-full ring-2 ring-white ${it.in ? "bg-emerald-500" : "bg-red-500"}`} />
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <div className={`h-9 w-9 rounded-full flex items-center justify-center ${it.in ? "bg-emerald-100 text-emerald-600" : "bg-red-100 text-red-600"}`}>
                      {it.in ? <ArrowDownLeft className="h-4 w-4" /> : <ArrowUpRight className="h-4 w-4" />}
                    </div>
                    <div>
                      <p className="text-sm font-semibold">{it.label}</p>
                      <p className="text-[11px] text-muted-foreground font-mono">{it.sub}</p>
                      <p className="text-[10px] text-muted-foreground">{new Date(it.ts).toLocaleString("en-IN")}</p>
                    </div>
                  </div>
                  <div className="text-right">
                    <p className={`font-mono font-semibold text-sm ${it.in ? "text-emerald-600" : "text-red-600"}`}>{it.in ? "+" : "-"}{inr(it.amount)}</p>
                    {S && <span className={`inline-flex items-center gap-1 mt-1 px-2 py-0.5 rounded-full text-[10px] font-semibold ${S.cls}`}><S.icon className="h-3 w-3" /> {S.hi}</span>}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
